/* src/app/modules/portal/components/settings/settings.component.scss */
.tableHead {
  width: 130px;
  text-align: left;
}
sh-dropdown {
  max-width: 300px;
}
.tableCell {
  width: 130px;
  text-align: left;
}
#settings-icon {
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
}
[title] {
  margin-bottom: 1rem;
}
[host] {
  padding: 1rem;
}
[option][aria-selected=true] {
  outline: var(--focus-outline);
}
[embedded] {
  --sh-checkbox-label-width: initial;
  margin: 1rem;
  border-radius: 0.25rem;
  padding: 0.5rem;
  padding-left: 1rem;
  position: relative;
  margin-left: 2rem;
  background-color: rgba(var(--ui-1), var(--opacity-7));
  border-left: 4px solid rgba(var(--functional-yellow), var(--opacity-1));
}
[embedded] [text] {
  display: flex;
  gap: 0.5rem;
  flex-direction: row;
}
[embedded] .modalities {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  column-gap: 1rem;
  margin-left: 2.25rem;
}
[embedded] .modalities > * {
  flex: 0 1;
  white-space: nowrap;
}
.timeline-example {
  margin-left: 52px;
}
[screen-phone] :host-context [embedded] .modalities {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
sh-drawer [icon=cancel] {
  position: absolute;
  top: 1rem;
  right: 1rem;
}
/*# sourceMappingURL=settings.component.css.map */
